import type { Dict } from './index';

// İngilizce sözlük — tr.ts ile aynı yapıda olmalı (tip zorunlu kılar).
export const en: Dict = {
  signInMethods: {
    // D-871 — the linked Google accounts, and removing one.
    googleAccountUnknown: "Google account (address not known yet)",
    googleLinkedDate: "Linked {date}",
    googleRemove: "Remove",
    googleRemoveTitle: "Remove this Google account?",
    googleRemoveBody: "You’ll confirm your registered number first. After that, this Google account can no longer sign in to nosubject.",
    googleRemoveConfirm: "Enter the code to remove {account}.",
    googleRemoved: "Google account removed.",
    googleLastMethod: "This is the only way to sign in to this account, so it can’t be removed.",
    googleAddAnother: "Link another Google account",
    googleLinkedCount: "Linked Google accounts: {count}",
    googleLinked: "Google account linked.",
    googleCodeSent: "A code was sent to your registered number ending in {phone}.",
    googleChooseHint: "The Google account you choose will be linked for signing in to this nosubject account.",
    googleStatusUnknown: "Couldn’t check the Google connection status. Please check again.",
    googleLinkIntro: "Verify this account’s registered phone number before linking Google.",
    googleLinkFailed: "Couldn’t complete the request. Please try again.",
    googleSendCode: "Send verification code",
    googleCodeLabel: "Verification code",
    googleStartAgain: "Start again",
    googleContinue: "Continue with Google",
    googleFailed: "Google sign-in could not be completed. Please try again.",
    googleNotLinked: "This Google account is not linked to a nosubject account yet.",
    googleUnavailable: "Google sign-in is not available yet.",
    title: "Sign-in methods",
    intro: "This section is being prepared. Options to manage sign-in methods will be added later.",
    identity: "Identity verification",
    identityInfo: "Verifying your identity is separate from signing in to your account.",
  },
  safety: {
    title: 'Safety number',
    compare: 'Compare this number with {name}. If it matches, nobody in between can read your messages.',
    explainInfo: 'The number comes from the encryption keys of all current devices of both of you, and both phones show the same one. If either of you adds a device, such as a new phone or the web, the number changes; compare it again then. The verification is kept only on this device.',
    qrLabel: 'QR code of the safety number',
    verified: 'Verified',
    notVerified: 'Not verified',
    markVerified: 'Mark as verified',
    clearVerified: 'Clear verification',
    peerUnavailable: 'Encryption is not on with this person yet.',
    selfUnavailable: 'This device’s encryption key is not ready yet.',
    loadFailed: 'The safety number could not be loaded.',
  },
  backup: {
    title: 'Chat backup',
    explainInfo: 'Your history lives on this device. A backup encrypts it with your recovery code and stores it on the server; we cannot open it.',
    create: 'Create backup',
    refresh: 'Update backup',
    codeTitle: 'Your recovery code',
    codeWarning: 'Save this code somewhere safe. If you lose it your history cannot come back, and we cannot open it either.',
    restoreTitle: 'Restore history',
    restorePlaceholder: 'Recovery code',
    restore: 'Restore',
    restored: '{count} messages restored.',
    restoreFailed: 'History could not be opened. Check the code.',
    failed: 'Backup failed.',
  },
  common: {
    clear: "Clear search",
    infoHide: 'Hide explanation: {subject}',
    infoShow: 'Show explanation: {subject}',
    continue: 'Continue',
    cancel: 'Cancel',
    close: 'Close',
    save: 'Save',
    done: 'Done',
    retry: 'Try again',
    error: 'Error',
    back: 'Back',
    search: 'Search…',
    loading: 'Loading',
    remove: 'Remove',
    offline: 'The server is unreachable. Check your connection.',
    sessionExpired: 'Your session ended. Sign in again.',
    tooManyRequests: 'Too many requests. Wait a little and try again.',
  },
  time: {
    now: 'now',
    minAgo: '{n} min ago',
    hourAgo: '{n} h ago',
    yesterday: 'yesterday',
    dayAgo: '{n} days ago',
    weekAgo: '{n} weeks ago',
    weekAgoOne: '{n} week ago',
    today: 'Today',
    dayYesterday: 'Yesterday',
  },
  phone: {
    sendFailed: "Couldn’t send the code. Please try again.",
    subtitle: 'Enter your phone number',
    selectCountry: 'Country / region',
    countrySearch: 'Search country…',
    architectureLink: 'Technical architecture and roadmap ↗',

  },
  otp: {
    verifyFailed: "Couldn’t verify the code. Please try again.",
    invalidCode: "The code is invalid or has expired.",
    rateLimited: "Too many attempts. Please try again later.",
    title: 'Enter the code',
    sentTo: 'We sent an SMS to {phone}',
    verify: 'Verify',
    resend: 'Resend',

    tooManyAttempts: 'Too many attempts. Wait a little and try again.',

    resendSent: 'A new code was sent.',
    resendFailed: 'The code could not be sent. Check your connection and try again.',
    resendWait: 'You can ask again in {n} s',
  },
  university: {
    title: 'Which university?',
    subtitle: 'Search for your university',
    placeholder: 'Harvard, Oxford…',
    skip: 'Skip',
  },
  profession: {
    title: 'What do you do?',
    subtitle: 'Search for your profession',
    placeholder: 'Teacher, developer, nurse…',
    skip: 'Skip',
  },
  // ISCO-08 ana grupları (meslek kovaları) — keşif filtresi + picker alt satırı.
  isco: {
    '0': 'Armed forces',
    '1': 'Managers',
    '2': 'Professionals',
    '3': 'Technicians & associate professionals',
    '4': 'Clerical support',
    '5': 'Service & sales',
    '6': 'Agriculture, forestry & fishing',
    '7': 'Craft & trades',
    '8': 'Plant & machine operators',
    '9': 'Elementary occupations',
  },
  // ISCED (UNESCO) education levels — global standard.
  isced: {
    '5': 'Associate',
    '6': "Bachelor’s",
    '7': "Master’s",
    '8': 'Doctorate',
  },
  profileCreate: {
    photoPickerFailed: "Could not open the photo library.",
    title: 'Create your profile',
    addPhoto: 'Add photo',
    name: 'Your name',
    surname: 'Your surname',
  },
  terms: {
    title: 'Before you start',
    age: 'I am over 18 years old',
    accept: 'I have read and accept the Terms of Service and Privacy Policy',
    termsLink: 'Terms of Service',
    privacyLink: 'Privacy Policy',
    continue: 'Accept and continue',
    saveFailed: 'Your consent could not be saved. Check your connection and try again.',
    docPlaceholder: 'This document will be published soon.',
  },
  locationConsent: {
    title: 'Location, only if you choose',
    body: 'To suggest the district and city when you take a photo, we need location permission.',
    privacy: 'This step does not read your location. It is used only after a successful capture, and your exact coordinates are not stored. You can change the permission later in device settings.',
    allow: 'Allow location',
    later: 'Not now',
  },
  discover: {
    title: "Discover",
    categories: "Occupation categories",
    categoryHint: "Explore people by the occupations shared on their profiles.",
    all: "All",
    reset: "Clear filters",
    failed: 'Could not load',
    free: 'Free',
    empty: 'No one here yet',
  },
  userProfile: {
    smsVerifiedOn: "Phone verified by SMS · {date}",
    googleLinkedOn: "Google account linked · {date}",
    contactProofNote: "Confirms access to a phone or Google account, not a person’s identity.",
    failed: 'Could not load profile',
    sendMessage: 'Send message',
    buyTime: 'Propose a meetup',
    block: 'Block',
    blockedNotice: '{name} is blocked. Messaging, calls and meetups are unavailable.',
    blockTitle: 'Block {name}?',
    blockMessage: 'They can’t message you or find you in Discover.',
    blockConfirm: 'Block',
  },
  callHistory: {
    empty: 'No calls yet',
    tabAll: 'All',
    tabMissed: 'Missed',
    emptyMissed: 'No missed calls',
    failed: 'Could not load calls',
    outgoing: 'Outgoing',
    incoming: 'Incoming',
    missed: 'Missed',
    declined: 'Declined',
    cancelled: 'Cancelled',
  },
  call: {
    title: 'Voice call',
    calling: 'Calling…',
    incoming: 'Incoming call',
    connecting: 'Connecting…',
    connected: 'Connected',
    reconnecting: 'Reconnecting…',
    logAnswered: 'Voice call',
    logAnsweredVideo: 'Video call',
    logNoAnswer: 'No answer',
    logMissed: 'Missed call',
    logDeclined: 'Call declined',
    logYouDeclined: 'You declined the call',
    logCancelled: 'Call cancelled',
    ended: 'Call ended',
    accept: 'Answer',
    decline: 'Decline',
    hangUp: 'Hang up',
    close: 'Close',
    mute: 'Mute microphone',
    unmute: 'Unmute microphone',
    cameraOff: 'Turn camera off',
    cameraOn: 'Turn camera on',
    flipCamera: 'Flip camera',
    audioOutput: 'Audio output: {route}',
    audioOutputTitle: 'Choose audio output',
    earpiece: 'Earpiece',
    speaker: 'Speaker',
    bluetooth: 'Bluetooth',
    bluetoothPermissionDenied: 'Bluetooth permission is off. Turn it on in Settings.',
    micPermission: 'Calls need microphone access. Turn it on in Settings.',
    micPermissionWeb: 'Calls need microphone access. Allow it in your browser’s site settings.',
    wiredHeadset: 'Wired headset',
    audioRouteFailed: 'Could not change the audio output',
    acceptFailed: 'Could not answer the call. Try again.',
    declineFailed: 'Could not decline the call. Try again.',
    endFailed: 'Could not end the call. Try again.',
    mediaConnectionFailed: 'The audio connection could not be established. The call ended without charge.',
    remaining: '{time} left',
    endingSoon: 'This call will end soon.',
    spent: '{amount} spent',
    earned: '{amount} earned',
    noAudioNotice: 'This build does not transmit audio yet. Call flow and billing are under test.',
    failed: 'Could not start the call',
    insufficient: 'Your balance is not enough for this call',
    busy: 'They are on another call',
    notAllowed: 'You can call once there is a message between you.',
    notAccepting: 'This person is not accepting calls right now',
    priceFree: 'Free',
    priceChanged: 'The call rate changed. Check the new rate and try again.',
    rateLimited: 'You’ve made too many call attempts. Wait a little and try again.',
    reservationLinkUnavailable: 'This booking can no longer be linked to the call. You can start a regular call instead.',
    missed: 'Missed call',
    callNow: 'Call now',
    videoNow: 'Video call now',
    scheduledStartTitle: 'Scheduled call',
    scheduledStartBody: 'Your scheduled call with {name} is starting. Call now?',
    schedule: 'Schedule a call',
    scheduleTitle: 'Schedule a call with {name}',
    subjectPlaceholder: 'Subject (optional)',
    priceNote: 'Call rate: {price}',
    sendReservation: 'Send booking request',
    reservationSent: 'Request sent',
    reservationSentBody: 'Your call booking request was sent to {name}.',
    reservationFailed: 'Could not send the call booking request',
    reservationBubble: '☎️ Call booking requested',
    reservationBubbleShort: '☎️ Call booking',
    reservationLabel: 'Voice call booking',
    rescheduleBubble: '☎️ New call time proposed',
    rescheduleBubbleShort: '☎️ New call time',
  },
  wallet: {
    otherAmount: "Other",
    customAmount: "Amount",
    customAmountHint: "Up to {amount}; at most two decimal places.",
    title: 'Wallet',
    failed: 'Could not load wallet',
    availableBalance: 'Available balance',
    earningsTitle: 'My earnings',
    earningsTotal: 'Total earned',
    earningsWithdrawable: 'Available to withdraw',
    earningsEscrow: 'Held in escrow',
    addFunds: 'Add funds',
    addFundsDemo: 'Demo: add test balance to your account',
    addFundsFailed: 'Could not add funds.',
    topupLabel: 'Funds added',
    transactions: 'Transactions',
    noTransactions: 'No transactions yet',
    waiting: 'pending',
    incomingRequest: 'incoming request',
    replied: 'replied',
    earned: 'earned',
    refunded: 'Refunded',
    requestPayout: 'Withdraw',
    payoutHint: 'You can withdraw up to {amount}.',
    payoutAll: 'Select full amount',
    payoutRequested: 'Request received',
    payoutRequestedBody: 'A withdrawal request for {amount} has been created and will be processed soon.',
    payoutFailed: 'Could not create withdrawal request',
    payoutRequests: 'Withdrawal requests',
    noPayouts: 'No withdrawal requests yet',
    payoutStatusPending: 'Pending',
    payoutStatusPaid: 'Paid',
    payoutStatusRejected: 'Rejected',
    paymentAccount: 'Payment account',
    stripeConnect: 'Connect payment account',
    stripeConnectInfo: 'Link your bank account to receive earnings (Stripe, test mode)',
    stripeConnected: 'Connected',
    stripeConnectFailed: 'Could not connect',
  },
  calendar: {
    dateInputLabel: "Date",
    timeInputLabel: "Time",
    dateInputHint: "Enter the year, month and day in YYYY-MM-DD format.",
    timeInputHint: "Enter the time in 24-hour HH:MM format.",

    previousWeek: 'Previous week',
    nextWeek: 'Next week',
    empty: 'No requests to show',
    failed: 'Could not load calendar',
    statusPending: 'Pending',
    statusAccepted: 'Accepted',
    statusDeclined: 'Declined',
    statusCancelled: 'Cancelled',
    statusExpired: 'Expired',
    accept: 'Accept',
    decline: 'Decline',
    cancel: 'Cancel',
    cancelConfirmationTitle: 'Cancel this reservation?',
    cancelConfirmationAcceptedBody: 'The confirmed reservation with {name} will be cancelled. The other person will be notified, and this cannot be undone.',
    cancelConfirmationPendingBody: 'The proposal sent to {name} will be withdrawn. The other person will be notified, and this cannot be undone.',
    actionFailed: 'Action failed',
    proposeTitle: 'Propose a meetup with {name}',
    locationPlaceholder: 'Where? (optional)',
    sendProposal: 'Send proposal',
    proposalSent: 'Proposal sent',
    proposalSentBody: 'Your meetup proposal was sent to {name}.',
    priceChangedBody: 'The rate for this reservation is now {amount}. No proposal was created — check the new rate and propose again.',
    proposalFailed: 'Could not send proposal',
    meetupBubble: '📅 Meetup proposed',
    meetupBubbleShort: '📅 Meetup proposal',
    proposeAction: '📅 Propose a meetup',
    priceNote: 'Meetup rate: {price}',
    totalCost: 'Total: {amount}',
    minutesShort: 'min',
    tabRequests: 'Requests',
    tabCalendar: 'Calendar',
    tabActive: 'Current',
    tabHistory: 'History',
    loadMore: 'Show more',
    noEventsForDay: 'No events on this day',
    meetupLabel: 'In-person meetup',
    reservationDetails: 'Reservation details',
    reservationParticipant: 'Person',
    reservationHeld: 'Call was held',
    reservationNotHeld: 'No call was made',
    reservationDateTime: 'Date and time',
    reservationDuration: 'Duration',
    reservationRate: 'Per minute',
    reservationLocation: 'Location',
    reservationSubject: 'Subject',
    reservationQuotedTotal: 'Quoted total',
    reservationBilledDuration: 'Billed duration',
    reservationSpentAmount: 'Amount paid',
    reservationEarnedAmount: 'Amount earned',
    reservationSettledAt: 'Settled',
    reservationCreated: 'Created',
    reservationResponded: 'Responded',
    reservationAcceptedAt: 'Accepted',
    reservationDeclinedAt: 'Declined',
    reservationCancelledAt: 'Cancelled',
    reservationCancelledBy: 'Cancelled by',
    reservationYou: 'You',
    reservationCancellationNotification: 'Notification dispatch',
    reservationNotificationPending: 'Preparing',
    reservationNotificationProviderAccepted: 'Accepted by the delivery provider',
    reservationNotificationSuppressed: 'Not sent because of notification preferences',
    reservationNotificationUnavailable: 'No eligible device was found',
    reservationPendingReschedule: 'Proposed new time',
    reservationNewTime: 'New date and time',
    proposeNewTime: 'Propose a new time',
    rescheduleFuture: 'The new start time must be in the future and at least one minute different from the currently scheduled start time.',
    reservationCallTooEarly: 'This scheduled call becomes available 15 minutes before it starts.',
    reservationCallExpired: 'The calling window for this reservation has ended.',
    reservationCallInProgress: 'The call linked to this reservation has already started.',
    reservationExecutionLocked: 'This scheduled call can no longer be changed because it has started or concluded.',
    openReservation: 'Open reservation details with {name}',
    systemEventMeetupTitle: 'Meetup with {name}',
    systemEventCallTitle: 'Scheduled call with {name}',
    systemEventNotes: 'Accepted through nosubject.',
    systemCalendarCopyRemoved: 'System calendar copy was deleted',
    restoreSystemCalendarCopy: 'Restore',
    systemCalendarRestoreFailed: 'Could not restore the calendar copy. Check calendar connections and system permission.',
    systemCalendarCopyChanged: 'System calendar time was changed',
    reviewSystemCalendarChange: 'Review',
    systemCalendarChangeTitle: 'Calendar time changed',
    systemCalendarChangeBody: 'This change was not applied to the other person.\n\nnosubject: {nosubject}\nSystem calendar: {system}',
    restoreNosubjectTime: 'Restore nosubject time',
    systemCalendarTimeRestoreFailed: 'Could not correct the calendar copy time. Check calendar connections and system permission.',
    proposeReschedule: 'Propose to the other person',
    rescheduleSent: 'New time proposed',
    rescheduleSentBody: 'Your new time was sent to {name}. The current time stays in place until they accept.',
    rescheduleFailed: 'Could not propose the new time.',
    rescheduleActionFailed: 'Could not update the time proposal.',
    reschedulePendingReceived: 'New time proposal: {time}',
    reschedulePendingSent: 'New time awaiting response: {time}',
    withdrawReschedule: 'Withdraw proposal',
    rescheduleBubble: '📅 New meetup time proposed',
    rescheduleBubbleShort: '📅 New meetup time',
    connectionsTitle: 'Calendar connections',
    connectionsInfo: 'Choose which calendars you want to see',
    deviceCalendar: 'Device calendars',
    connect: 'Connect',
    openSettings: 'Open settings',
    permissionGranted: 'Access granted',
    permissionDenied: 'Access is off',
    permissionUnavailable: 'Unavailable in this build',
    permissionNotRequested: 'Not connected yet',
    devicePermissionInfo: 'Permission is requested only after you tap this button. nosubject reads only your selected calendars and the required time range; it does not write events from this screen.',
    selectCalendars: 'Calendars to display',
    noDeviceCalendars: 'No event calendars are available on this device.',
    manageSystemPermission: 'Manage system calendar permission',
    connectionPrivacyInfo: 'Your selection is stored on this device for this nosubject account. External event details will be used only in your own calendar view and will not be shared with other users automatically.',
    newBuildRequired: 'A newer app build is required for calendar connections.',
    connectionFailed: 'Could not connect the calendar.',
    disconnect: 'Disconnect',
    disconnectTitle: 'Disconnect calendar?',
    disconnectBody: 'nosubject will stop reading calendars and writing newly accepted events on this device. Selections and local mappings are cleared; existing system-calendar events remain. You can revoke system permission separately in device settings.',
    disconnectFailed: 'Could not disconnect the calendar.',
    selectionSaveFailed: 'Could not save the calendar selection.',
    allDay: 'All day',
    recurring: 'Recurring',
    availabilityFree: 'Available',
    availabilityBusy: 'Busy',
    availabilityTentative: 'Tentative',
    availabilityUnavailable: 'Unavailable',
    untitledExternalEvent: 'Untitled event',
    externalEventsFailed: 'Could not load external calendar events.',
    hideExternalEvent: 'Hide {title} from this view',
    hideExternalEventFailed: 'Could not hide the event.',
    restoreHiddenExternalEvents: 'Show hidden events again',
    restoreHiddenExternalEventsFailed: 'Could not show hidden events again.',
    hiddenExternalEventCount: '{count} events hidden on this device',
    checkIncompleteTitle: 'Calendar check incomplete',
    checkIncompleteBody: 'At least one calendar source could not be read temporarily, so we cannot confirm that this time is completely free. You can still continue if you want.',
    conflictCheckIncomplete: 'Some calendars could not be read, so there may be other conflicts.',
    conflictTitle: 'Calendar conflict',
    reservationUnavailable: 'This time is no longer available because of another confirmed reservation.',
    reservationChanged: 'This booking changed on another screen or device. We loaded the latest version.',
    reservationPast: 'A reservation whose start time has passed cannot be accepted.',
    conflictBody: 'This time overlaps another event in your calendar. You can still continue if you want.',
    tentativeConflictTitle: 'Tentative calendar event',
    tentativeConflictBody: 'A calendar event at this time is not confirmed yet. Check the details before continuing.',
    conflictMore: '• More events: {count}',
    continueAnyway: 'Continue anyway',
    onlineCalendars: 'Online calendars',
    googleCalendar: 'Google Calendar',
    providerConnected: 'Connected',
    providerNotConnected: 'Not connected',
    providerUnavailable: 'Official connection setup is being prepared',
    googlePrivacyInfo: 'Only calendars you select are synchronized. Titles and locations are encrypted in a minimal server cache; descriptions, attendees and conference links are not stored. nosubject cannot create, change or delete Google Calendar events.',
    googleConnectionFailed: 'Could not start the Google Calendar connection.',
    microsoftCalendar: 'Microsoft Calendar',
    microsoftInfo: 'nosubject only reads your availability (Calendars.Read). It cannot create, change or delete events. Access is removed in your Microsoft account settings; nosubject cannot revoke it on its own.',
    microsoftConnectionFailed: 'Could not start the Microsoft Calendar connection.',
    googleDisconnectTitle: 'Disconnect Google Calendar?',
    googleDisconnectBody: 'nosubject will stop accessing Google Calendar data and revoke the Google permissions you granted to nosubject. Events in Google Calendar will not be deleted.',
    googleDisconnectFailed: 'Could not disconnect Google Calendar.',
    googleNoCalendars: 'No readable Google calendars were found.',
    googleSelectionSaveFailed: 'Could not save the Google Calendar selection.',
  },
  instagram: {
    title: 'Instagram connection',
    connectInfo: 'Connect your professional account with explicit consent',
    connectedAccounts: 'Connected accounts',
    professionalAccount: 'Professional account',
    connect: 'Connect',
    reconnect: 'Reconnect',
    connectedAs: '@{username} · {accountType}',
    notConnected: 'Not connected yet',
    unavailable: 'The official connection is being prepared',
    privacyInfo: 'The first stage requests only instagram_business_basic to read professional-account identity. It requests no messaging, comment or publishing permission, and copies no photos to nosubject until you separately choose to import them.',
    business: 'Business',
    creator: 'Creator',
    connectionFailed: 'Could not start the Instagram connection.',
  },
  inbox: {
    markUnread: 'Mark as unread',
    markRead: 'Mark as read',
    archiveTitle: 'Archive',
    archive: 'Archive',
    failed: 'Could not load conversations',
    searchEmpty: 'No results',
    archivedEmpty: 'No archived conversations',
    empty: 'No conversations yet',
    you: 'You:',
    archived: 'Archived',
    unarchived: 'Unarchived',
    undo: 'Undo',
    mute: 'Mute notifications',
    muteTitle: 'Mute notifications from {name}',
    mute1h: 'For 1 hour',
    mute8h: 'For 8 hours',
    mute1w: 'For 1 week',
    muteForever: 'Until I turn it off',
    unmute: 'Unmute notifications',
    archiveAction: 'Archive',
    unarchiveAction: 'Unarchive',
    swipeRemove: 'Unarchive',
    swipeArchive: 'Archive',
    blockAction: 'Block',
    blockTitle: 'Block {name}?',
    blockMessage: 'They can’t message you or find you in Discover.',
    blockConfirm: 'Block',
  },
  // 9.33.9.3 / D-780 — passkeys, named as the system names them.
  passkeys: {
    // D-882 — signing in with a passkey.
    signIn: "Sign in with passkey",
    signInIntro: "With a passkey you can sign in without your phone number or a code.",
    signInNone: "This device has no passkey for nosubject. Sign in with your phone number first, then add one in Profile → Settings → Sign-in methods → Passkeys.",
    signInFailed: "Couldn’t sign in with your passkey. Please try again.",
    // D-876 — a lost passkey, reset after a 48-hour wait.
    lost: "Lost your passkey?",
    recoveryIntro: "If no device of yours still has your passkey, you can reset it. After you confirm your number, there is a 48-hour wait. We’ll tell you in your chat, and anyone holding your passkey can cancel the reset.",
    recoveryPending: "Your reset will be ready on {date}.",
    recoveryCancel: "Cancel reset",
    recoveryCancelled: "Reset cancelled.",
    recoveryReady: "Your reset is ready. Add your new passkey.",
    recoveryDone: "Your new passkey was added. The old ones no longer work.",
    title: "Passkeys",
    intro: "A passkey confirms it’s you the way you unlock this device. It stays on your device; nosubject never receives your face or fingerprint.",
    taskIntro: "Messages you send to nosubject’s official account are confirmed with a passkey before they go.",
    empty: "You have no passkey yet.",
    add: "Add a passkey",
    remove: "Remove",
    removeTitle: "Remove this passkey?",
    removeBody: "You’ll confirm with a passkey first.",
    added: "Passkey added.",
    removed: "Passkey removed.",
    addedOn: "Added {date}",
    lastUsed: "Last used {date}",
    unnamed: "Passkey",
    reauthIntro: "To add your first passkey, confirm your registered phone number.",
    sendCode: "Send verification code",
    codeSent: "A code was sent to your registered number ending in {phone}.",
    codeLabel: "Verification code",
    startAgain: "Start again",
    wrongCode: "That code didn’t work. Send a new one.",
    failed: "Couldn’t complete the request. Please try again.",
    exists: "This device already has a passkey for your account.",
    unsupportedApp: "This version of the app can’t use passkeys yet. They come with the next app update.",
    unsupportedWeb: "This browser can’t use passkeys.",
    tapTitle: "Continue with your passkey",
    tapAction: "Continue",
  },
  message: {
    jumpLatest: 'Jump to latest message',
    info: "Message info",
    infoSentAt: "Sent",
    infoReadAt: "Read",
    infoPlatform: "Sent from",
    // 9.33.9.4 — a message to the task chat stopped for its passkey.
    passkeyNeededTitle: "Add a passkey first",
    passkeyNeededBody: "Messages to this account are confirmed with a passkey. Add one, then send again.",
    passkeyUnavailable: "This message needs your passkey, which this version of the app can’t use yet. Send it from nosubject.co, or after the next app update.",
    passkeyFailed: "The message couldn’t be confirmed, so it wasn’t sent.",
    forwardOwn: "Forward",
    forwardHint: "Choose a conversation. The text opens as a draft; sending and the current price confirmation remain separate.",
    forwardEmpty: "No other active conversations.",
    forwardDraftFirst: "Send or clear your current draft first.",
    translationLanguage: "Translation language",
    chooseTranslationLanguage: "Choose a translation language",
    languageSuggestion: "Device language suggestion",
    translationLanguageInfo: "This private preference applies to translations in all your conversations. It is not added to your profile.",
    photoCaption: "Add a photo caption…",
    removePhoto: "Remove photo",
    star: "Star message",
    unstar: "Unstar message",
    starred: "Starred messages",
    noStars: "No starred messages in this conversation.",
    starFailed: "Could not update stars. Please try again.",
    starredAttachment: "Message with attachment",
    edit: "Edit message",
    edited: "Edited",
    editInfo: "You can edit until the message is read, even with read receipts off. Losing the Edit option can reveal that it was read. Unread does not mean unseen: a notification preview may have shown the original. Editing cannot guarantee taking your words back.",
    editFailed: "Could not confirm the edit. The message may have been read or changed. Check the conversation before trying again.",
    copy: "Copy",
    copyFailed: "Couldn’t copy the message. Please try again.",
    inputPlaceholder: 'Type a message…',
    typing: 'Typing',
    translate: 'Translate',
    withdrawn: 'Message withdrawn',
    linkOpenTitle: 'Open link',
    linkOpenBody: 'This takes you to {host}. The link was sent by the person messaging you — be careful if you do not know them.',
    linkOpenConfirm: 'Open',
    linkOpenFailed: 'The link could not be opened.',
    seenAt: 'Seen {time}',

    priceChangedTitle: 'The price changed',
    priceChangedBody: 'This message now costs {new}, not {old}. Send it anyway?',
    priceChangedSend: 'Send',
    priceNoticeTitle: 'What talking to this person costs',
    priceNoticeMessage: '{amount} per message',
    priceNoticeCall: 'Calls {amount}',
    priceNoticePersonal: 'These rates were set for you specifically.',
    priceDecreasedTitle: "Message price decreased",
    priceDecreasedBody: "Messages now cost {new} instead of {old}. No approval is needed for the lower price.",
    priceChange: {
      free: 'free',
    },

    expired: 'expired, refunded',
    // 9.2 / D-650 — web'den gönderilen mesajın saat satırındaki notu.
    sentFromWeb: 'via web',
    linkViewLabel: 'Link view',
    linkViewPlain: 'Plain address',
    linkViewCompact: 'Compact',
    linkViewCard: 'Large card',
    linkPreviewLoading: 'Preparing preview…',
    linkPreviewFailed: 'Couldn’t get a preview for this link; it will go as a plain address.',
    linkPreviewA11y: 'Link: {title}, {host}',
    customPrice: 'Custom price',
    priceUsesGeneral: 'My general price applies',
    priceRemove: 'Remove from contacts',
    priceRemoveTitle: 'Remove {name} from your contacts?',
    priceRemoveBody: 'The custom price goes away and {name} falls back to your general price. If only contacts can message you, they can no longer start a new conversation. This is not a block.',
    priceRemoveConfirm: 'Remove',
    priceRemoved: '{name} is back on your general price.',
    pricePrompt: 'Prices for {name} (0 = free):',
    saved: 'Saved',
    priceFreeSet: '{name} can now message you for free.',
    priceSet: 'Price for {name} set to {price}.',
    saveError: 'Could not save.',
    photoError: 'Could not send photo.',
    noConnection: 'No connection',
    checkInternet: 'Check your internet connection.',
    sendError: 'Could not send message.',
    addAttachment: 'Add attachment',
    sendMessageAction: 'Send message',
    lowBalanceTitle: 'Not enough balance',
    lowBalanceBody: 'Your wallet balance is below this person’s message price. Add funds and try again.',
    reply: 'Reply',
    reactionA11y: '{emoji} reaction, {count} in total',
    reactionA11yMine: '{emoji} reaction, {count} in total, including yours',
    reactionAdd: 'React with {emoji}',
    moreReactions: 'More emojis',
    reactionRemove: 'Remove your {emoji} reaction',
    you: 'You',
    photo: '📷 Photo',
    takePhoto: 'Take a photo',
    choosePhoto: 'Choose from library',
    chooseVideo: 'Choose a video',
    recordVoice: 'Voice message',
    micPermissionTitle: 'Microphone access needed',
    micPermissionBody: 'Recording a voice message needs microphone access.',
    voiceError: 'Voice message could not be sent',
    voiceRecording: 'Recording',
    videoTooLarge: 'Video is too large (1 GB maximum)',
    videoTooLong: 'Video is too long (10 minutes maximum)',
    videoError: 'Video could not be sent',
    videoNeedsUpdate: 'Update the app to watch this video',
    voiceNeedsUpdate: 'Update the app to play this voice message',
    voiceOrderTitle: 'Voice message ordered',
    encrypted: 'Encrypted message',
    identityChanged: 'The security key for this person changed. It usually means a new phone or a reinstalled app.',
    identityChangedVerify: 'You had verified this chat; compare the safety number again.',
    unencrypted: 'This chat isn’t encrypted',
    unencryptedPeerInfo: 'The other person’s app doesn’t support end-to-end encryption yet, so what you write here is sent unencrypted and can be read on nosubject’s server. When they update their app, new messages are encrypted automatically.',
    unencryptedOfficialInfo: 'This is nosubject’s official account. What you write here is sent unencrypted and can be read by the nosubject team.',
    unencryptedSelfInfo: 'Encryption couldn’t be turned on on this device (for example, a private browser window can’t keep keys). What you send from here is unencrypted and can be read on nosubject’s server.',
    notificationOfferEnable: 'Turn on notifications',
    notificationOfferEnabled: 'Notifications are on',
    voiceOrderPending: 'Waiting for delivery',
    voiceOrderDelivered: 'Delivered',
    voiceOrderDeclined: 'Declined, refunded',
    voiceOrderExpired: 'Expired, refunded',
    voiceOrderAction: 'Order a voice note',
    voiceOrderPick: 'How long a recording?',
    voiceOrderInsufficient: 'Your balance is not enough for this order.',
    voiceOrderError: 'The order could not be placed.',
    voiceOrderRecord: 'Record and send',
    voiceOrderDecline: 'Decline',
    voiceOrderDeclineTitle: 'Decline the order',
    voiceOrderDeclineBody: 'The whole reserved amount goes back to the person who ordered.',
    voiceOrderDeclineError: 'The order could not be declined.',
    voiceOrderDeliverError: 'The recording could not be delivered.',
    voiceOrderRecording: 'Order recording',
    voiceOrderRemaining: '{length} left',
    voiceOrderShortNote: 'Send a shorter one and only what you record is paid for.',
    voiceOrderRefunded: '{amount} refunded',
    sendLocation: 'Send location',
    locationTitle: 'Location',
    locationError: 'Location could not be sent',
    shareLiveLocation: 'Share live location',
    liveLocationHour: '1 hour',
    liveLocationEightHours: '8 hours',
    liveLocationOpenEnded: 'Until I stop it',
    liveLocationSharing: 'Sharing your live location',
    liveLocationStop: 'Stop',
    liveLocationError: 'Live location could not be started',
    liveLocationCardTitle: 'Live location',
    liveLocationCardActive: 'Sharing now',
    liveLocationCardEnded: 'Sharing ended',
    liveLocationOpen: 'See location',
    liveLocationNoPoint: 'No position yet',
    liveLocationOpenInMaps: 'Open in Maps',
    locationMapError: 'The map could not be opened.',
    liveLocationUpdatedAgo: 'Updated {ago}',
    videoShort: '🎬 Video',
    voiceShort: '🎙 Voice message',
    liveLocationWatchedAgo: 'Looked {ago} ago',
    liveLocationNotWatched: 'Not looked at yet',
    liveLocationSharerSeesYou: 'They can see when you look',
    cameraPermissionTitle: 'Camera access required',
    cameraPermissionBody: 'Allow camera access to take a photo.',
    cameraError: 'Could not open the camera.',
    photoLocationTitle: 'Photo location',
    photoLocationPromptFile: '{place} was read from the photo file. Show this location with the photo?',
    photoLocationPromptCapture: 'Your device location identified {place}. Show this location with the photo?',
    photoLocationHide: 'Send without location',
    photoLocationShare: 'Send with location',
    photoLocationFromFile: 'Read from file',
    photoLocationFromCapture: 'Device location',
    photoLocationHideAfter: 'Hide location',
    photoLocationShowAfter: 'Show location',
    photoLocationUpdateError: 'Could not update the photo location.',
  },
  versionNotice: {
    title: 'A new version is available',
    body: 'Update the app for security fixes and new features.',
    update: 'Update',
  },
  notifications: {
    title: 'Notifications',
    cardBody: 'Turn on device notifications so you don’t miss new messages and replies.',
    notNow: 'Not now',
    enable: 'Turn on notifications',
    device: 'Device notifications',
    stateOn: 'On · Manage in system settings',
    stateOff: 'Off · Turn on in system settings',
    stateAsk: 'Not asked yet',
    preferences: 'Notification preferences',
    preferencesInfo: 'Manage categories, previews and device permission',
    stateUnsupported: 'Not supported on this device',
    master: 'All notifications',
    masterInfo: 'Turning this off stops all push notifications without erasing category choices',
    categories: 'Categories',
    categoryEnabled: 'Notifications in this category',
    categoryEnabledInfo: 'Turning this off stops push notifications for this category without erasing its choices',
    events: 'Events',
    messages: 'Messages',
    messagesInfo: 'New messages and replies',
    meetups: 'Meetups',
    meetupsInfo: 'Proposals, changes and outcomes',
    meetupRequests: 'New meetup proposals',
    meetupRequestsInfo: 'When someone sends you a new meetup proposal',
    meetupUpdates: 'Proposal responses and cancellations',
    meetupUpdatesInfo: 'When a meetup is accepted, declined or cancelled',
    meetupReminders: 'Meetup reminders',
    meetupRemindersInfo: 'When an accepted meetup is approaching',
    calls: 'Calls',
    callsInfo: 'Incoming, scheduled and missed calls',
    incomingCalls: 'Incoming calls',
    incomingCallsInfo: 'A sound alert when someone calls you',
    callRequests: 'Scheduled-call proposals',
    callRequestsInfo: 'When a proposal is created, accepted, declined or cancelled',
    callReminders: 'Scheduled-call reminders',
    callRemindersInfo: 'When an accepted call is approaching',
    missedCalls: 'Missed calls',
    missedCallsInfo: 'When you could not answer a call',
    financial: 'Money and escrow',
    financialInfo: 'Transaction status changes',
    financialEarnings: 'Earnings and escrow',
    financialEarningsInfo: 'When escrow is released or earnings become available',
    financialRefunds: 'Refunds and expiry',
    financialRefundsInfo: 'When a payment is refunded or escrow expires',
    financialPayouts: 'Payout results',
    financialPayoutsInfo: 'When a payout request succeeds or fails',
    reactions: 'Emoji reactions',
    reactionsInfo: 'Reactions to your messages',
    official: 'From Nosubject',
    officialInfo: 'Nosubject’s announcements about versions, security and your account. Separate from your other notifications; turn it off and Nosubject sends no notifications, though its messages still reach your inbox.',
    preview: 'Message preview',
    previewHidden: 'Hidden',
    previewHiddenInfo: 'Show neither sender nor message',
    previewSender: 'Sender only',
    previewSenderInfo: 'Show sender and hide message',
    previewText: 'Sender and message',
    previewTextInfo: 'Show up to 80 characters',
    deviceInfo: 'Operating-system permission is specific to this device',
    openSettings: 'Open settings',
    centerTitle: 'Notification Center',
    centerMarkAll: 'Mark all read', centerMarkedAll: 'All marked as read',
    centerEmpty: 'No notifications yet.',
    centerFailed: 'Notifications could not be loaded.',
    centerMarkAllFailed: 'Notifications could not be marked as read.',
    centerUnknownPerson: 'Someone',
    centerEscrowExpiredRefunded: 'Escrow expired · payment refunded',
    centerEscrowReleasedEarning: 'Reply completed · earnings added',
    centerMeetupRequest: '{name} sent you a meetup proposal',
    centerCallRequest: '{name} sent you a scheduled-call proposal',
    centerCallReminder: 'Your scheduled call with {name} is coming up',
    centerCallStarting: 'Your scheduled call with {name} is starting',
    centerMeetupStarting: 'Your meetup with {name} is starting',
    centerMeetupReminder: 'Your meetup with {name} is coming up',
    centerMeetupUpdate: '{name} · Meetup {status}',
    centerCallUpdate: '{name} · Scheduled call {status}',
    centerMeetupRescheduleRequest: '{name} proposed a new meetup time',
    centerCallRescheduleRequest: '{name} proposed a new call time',
    centerMeetupRescheduleUpdate: '{name} · New meetup time {status}',
    centerCallRescheduleUpdate: '{name} · New call time {status}',
    centerBell: 'Notification Center',
    centerBellUnread: 'Notification Center, unread: {count}',
  },
  profile: {
    viewPhoto: "View profile photo",
    photoUnavailable: "This photo could not be loaded.",
    // 9.35.3 · D-830 — profile photos and videos.
    photos: "Photos",
    mediaPhotoLabel: "Photo {n} of {total}",
    mediaVideoLabel: "Video {n} of {total}",
    mediaUnavailable: "Photos could not be loaded",
    mediaMore: "Show more",
    // 9.35.4 · D-830 — removing one's own photo or video.
    mediaRemove: "Remove from profile",
    mediaRemovePhotoTitle: "Remove this photo from your profile?",
    mediaRemoveVideoTitle: "Remove this video from your profile?",
    mediaRemoveBody: "The file is deleted and can’t be restored.",
    mediaRemoveFailed: "Couldn’t remove it. Try again.",
    webVisibility: 'Who can see my web page',
    webVisibilityLink: 'With the link',
    webVisibilityInfo: 'Your profile as people without an account see it: your page at nosubject.co/your-username. Everyone: your page can also appear in search engines. With the link: anyone who has the address can open it; search engines don’t list it. With either of these, people without an account can reach your profile details, including your last seen. Nobody: no one without an account can see your profile; the page says “This profile isn’t available”. Your profile in the app doesn’t change. Leaving search results can take a few days.',
    linkViewInfo: 'Choose how a link you type is sent. For Compact and Large card, your phone opens the page once and sends the preview with the message; that site sees your phone’s IP address. In an encrypted chat the preview is inside the encryption; in an unencrypted chat nosubject sees the link and the preview. Plain address opens no page. Links sent from the web always go as a plain address.',
    linkViewAsk: 'Show options while typing',
    linkViewAskInfo: 'When on, the other two views appear while you type a link, and you can pick one for that message. When off, links always go in the view you choose here.',
    whoCanCallInfo: 'Choose who can call you; it applies to every call. My contacts are the people you have given a personal price. With Exceptions you can allow or block people one by one.',
    whoCanMessageInfo: 'Choose who can start a new conversation with you; conversations that have already started are not affected. My contacts are the people you have given a personal price. With Exceptions you can allow or block people one by one.',
    readReceiptsInfo: "Read receipts are visible only when both people enable them. Even with receipts off, losing the Edit option can reveal that a message was read.",
    showTypingInfo: 'When it is on, the person you are writing to can see that you are typing. If you turn it off, no one sees it, and you still see when others are typing.',
    officialAccount: 'Official account',
    information: 'Profile information',
    logout: 'Log out',
    account: 'Account',
    accountData: 'Account & data',
    name: 'Name',
    surname: 'Surname',
    username: 'Username',
    usernamePlaceholder: 'username',
    usernameChecking: 'Checking…',
    usernameAvailable: 'Available',
    usernameTaken: 'This username is taken',
    usernameInvalid: 'Use 3–20 characters. Start with A–Z or a–z; then use A–Z, a–z, 0–9 or _.',
    usernameAdd: 'Add a username',
    profession: 'Profession',
    professionNone: 'No profession added',
    professionAdd: 'Add profession',
    employer: 'Company',
    employerPlaceholder: 'companyusername',
    employerInfo: 'Enter an existing nosubject username. This attribution does not mean the workplace is verified.',
    employerNotFound: 'No active account with that username was found.',
    employerSelf: 'You cannot list your own account as your company.',
    bio: 'Tell people about yourself…',
    prices: 'Prices',
    settings: 'Settings',
    priceMessage: 'Message',
    priceVoice: 'Voice message (per minute)',
    priceVoiceShort: 'Voice message',
    priceCall: 'Call now (per minute)',
    priceCallShort: 'Call now',
    priceScheduledCall: 'Schedule a call (per minute)',
    priceScheduledCallShort: 'Schedule a call',
    priceVideoCall: 'Video call',
    priceVideoCallShort: 'Video',
    priceTime: 'Meetup (per minute)',
    priceTimeShort: 'Meetup',
    currency: 'Currency',
    saving: 'Saving…',
    wallet: 'Wallet',
    chatBackup: 'Chat backup',
    privacy: 'Privacy',
    readReceipts: 'Read receipts',
    showTyping: 'Typing indicator',
    keepArchived: 'Keep archived',
    keepArchivedInfo: 'If off, a new message unarchives the conversation',
    whoCanMessage: 'Who can message me',
    whoCanCall: 'Who can call me',
    messagesFromContact: 'Messages from this person',
    callsFromContact: 'Calls from this person',
    callExceptions: 'Exceptions',
    callExceptionsEmpty: 'No call exceptions yet',
    messageExceptionsEmpty: 'No message exceptions yet',
    exceptionsLoadFailed: 'Could not load exceptions',
    openProfileHint: 'Opens this person’s profile',
    callExceptionBlocked: 'Blocked',
    callsFromContactDefault: 'Default',
    callsFromContactAllow: 'Always allow',
    callsFromContactBlock: 'Never',
    everyone: 'Everyone',
    contacts: 'My contacts',
    nobody: 'Nobody',
    blockedUsers: 'Blocked users',
    blockedEmpty: 'You haven’t blocked anyone',
    unblock: 'Unblock',
    appearance: 'Appearance',
    light: 'Light',
    dark: 'Dark',
    system: 'System',
    displayLanguage: 'Display language',
    education: 'University',
    educationAdd: 'Add university',
    educationNone: 'No university added',

    educationLevel: 'Education level',
    searchLanguage: 'Search language…',
    photoChange: 'Change',
    saveFailed: 'Could not save.',
    photoFailed: 'Could not upload photo.',
    photoChanged: "The photo changed in another operation or the retry period expired. Please select the photo again.",
    deleteAccount: 'Delete account',
    deleteTitle: 'Delete your account',
    deleteMessage: 'Your account will be permanently deleted after 30 days. You can log back in during this period to cancel.',
    deleteMoneyWarning: 'You have {amount} in your wallet and escrow. We recommend withdrawing it before deleting.',
    deleteConfirm: 'Delete',
    deleteFailed: 'Could not delete account.',
    deletionScheduled: 'Your account will be deleted on {date}.',
    deletionCancel: 'Cancel account deletion',
    exportData: 'Download my data',
    exportFailed: 'Could not fetch data.',
  },
  // Alt bar (dock) — ekran okuyucu etiketleri ve rozet sayıları (9.26.7.2.1)
  dock: {
    calls: 'Calls',
    discover: 'Discover',
    inbox: 'Messages',
    calendar: 'Calendar',
    profile: 'Profile',
    unreadMessages: '{count} unread',
    pendingRequests: '{count} pending',
  },
  // 9.18.10.4 · D-830 — importing one's own Instagram download.
  instagramImport: {
    title: "Import from Instagram",
    addEntry: "Import from Instagram",
    guideIntro: "Download your own Instagram data and choose it here to add your photos and videos to your profile.",
    guideStep1: "In Instagram, go to Accounts Center → Your information and permissions → Download your information.",
    guideStep2: "Under “Some of your information”, choose Content only; format JSON, media quality High.",
    guideStep3: "When Meta has prepared the file, download it and choose it here.",
    guideOwnOnly: "Only photos and videos you posted are listed; media in messages is never taken.",
    guideOnDevice: "The file is opened on your device and never sent to our server; only what you choose is uploaded.",
    choose: "Choose the ZIP file",
    reading: "Reading the archive",
    notZip: "This file isn’t a ZIP archive.",
    untrusted: "This archive doesn’t look safe, so it wasn’t opened.",
    tooBig: "This archive is too large.",
    unreadable: "This archive couldn’t be read.",
    chooseAnother: "Choose another file",
    noMedia: "No photos or videos that can be added were found in this archive.",
    found: "{count} photos and videos found",
    slotsLeft: "{count} places left on your profile",
    selectAll: "Select all",
    selectNone: "Clear selection",
    alreadyOnProfile: "On profile",
    tooLarge: "Too large",
    add: "Add {count}",
    adding: "Adding {n} of {total}",
    stop: "Stop",
    stopping: "Stopping after this one",
    doneAdded: "{count} added",
    doneDuplicate: "{count} already on your profile",
    doneSkipped: "{count} skipped",
    doneFailed: "{count} couldn’t be added",
    retryFailed: "Try the rest again",
    profileFull: "Your profile is full; no more could be added.",
    guideParts: "If Meta split your download into several ZIP parts, choose them all together.",
    catAll: "All",
    catPosts: "Posts",
    catReels: "Reels",
    catStories: "Stories",
    catIgtv: "IGTV",
    catArchived: "Archived",
    catProfile: "Profile photos",
    catOther: "Other",
    archiveSection: "Instagram download",
    archiveHint: "Adds the photos and videos from your own data download to your profile.",
  },
};
